import {
  startLoading,
  stopLoading,
  startEditing,
  featuredClusterEditReorder,
  featuredClusterEditSave,
  featuredClusterEditAddCluster,
  featuredClusterEditRemoveCluster,
} from './featured-cluster-edit.actions';
import { put, take, call, select } from 'redux-saga/effects';
import { getClusterList } from '../ClusterList/clusterlist.actions';
import {
  loadFeaturedClusters,
  updateFeaturedClusters,
  addFeaturedCluster,
  removeFeaturedCluster as removeFeaturedClusterAction,
} from '../Entities/FeaturedCluster/featured-cluster.actions';
import { merge, indexBy, prop, length } from 'ramda';
import {
  FeaturedCluster,
  getDirtyFeaturedClusters,
} from '../Entities/FeaturedCluster/featured-cluster.reducer';
import {
  saveFeaturedClusters,
  removeFeaturedCluster,
} from '../Entities/FeaturedCluster/featured-cluster.saga';

export function* watchForFeatureClusterEditStart() {
  while (true) {
    yield take(startEditing.type);

    yield put(startLoading());

    yield put(loadFeaturedClusters());

    yield put(getClusterList());

    yield put(stopLoading());
  }
}

export function* watchForFeatureClusterEditReorder() {
  while (true) {
    const { payload } = yield take(featuredClusterEditReorder.type);
    const newPositioned: FeaturedCluster[] = payload.map(
      (item: FeaturedCluster, key: number) => merge(item, {
        position: key + 1,
        dirty: true,
      })
    );
    const indexed = indexBy(prop('id'), newPositioned) as {
      [key: number]: FeaturedCluster;
    };
    yield put(updateFeaturedClusters(indexed));
  }
}

export function* watchForFeaturedClusterEditSave() {
  while (true) {
    yield take(featuredClusterEditSave.type);

    yield put(startLoading());

    const state = yield select();

    const clustersToSave = getDirtyFeaturedClusters(state);

    if (length(clustersToSave) > 0) {
      yield call(saveFeaturedClusters, clustersToSave);
    }

    yield put(stopLoading());
  }
}

export function* watchForFeaturedClusterEditAddCluster() {
  while (true) {
    const { payload } = yield take(featuredClusterEditAddCluster.type);

    yield put(addFeaturedCluster(payload));
  }
}

export function* watchForFeaturedClusterEditRemoveCluster() {
  while (true) {
    const { payload } = yield take(featuredClusterEditRemoveCluster.type);

    yield put(removeFeaturedClusterAction(payload));
    yield call(removeFeaturedCluster, payload);
  }
}



// WEBPACK FOOTER //
// ./src/store/FeaturedClusterEdit/featured-cluster-edit.saga.ts